import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, useLocation } from 'react-router-dom'
import { ApolloProvider } from '@apollo/client/react'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { newClient } from 'utils/apollo-client'
import { SessionProvider } from 'context/SessionProvider'

// Sass leaves `@import`s of .css files as plain CSS at-rules, so these are
// loaded here instead of from index.scss. Order matters: backer-ui's base
// layer first, then our overrides.
import '@collegebacker/backer-ui/ui/ui.css'
import '@collegebacker/backer-ui/ui/base.css'
import './index.scss'

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={newClient}>
      <HelmetProvider>
        <SessionProvider>
          <BrowserRouter>
            <ScrollToTop />
            <App />
          </BrowserRouter>
        </SessionProvider>
      </HelmetProvider>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

reportWebVitals()

function ScrollToTop() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0)
    }
  }, [pathname, hash])

  return null
}
